import {
  ColumnDate,
  ColumnLink,
  ColumnValue,
  ColumnAmount,
  AsyncGridColumns,
} from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.movement type',
    field: 'moveFundsType',
    renderCell: ({ row }) => (
      <ColumnLink to={row.id}>{row.moveFundsTypeLabel}</ColumnLink>
    ),
    minWidth: 140,
  },
  {
    headerName: 'column.operation date',
    field: 'appliedAt',
    renderCell: ({ row }) => <ColumnDate type='date' value={row.appliedAt} />,
    minWidth: 140,
  },
  {
    headerName: 'column.operation time',
    field: 'appliedAtTime',
    sortable: false,
    renderCell: ({ row }) => <ColumnDate type='time' value={row.appliedAt} />,
    minWidth: 150,
  },
  {
    headerName: 'column.account',
    field: 'aggregatorAccountTitle',
    minWidth: 240,
  },
  {
    headerName: 'column.driver',
    field: 'driverFullName',
    renderCell: ({ row }) => (
      <ColumnLink to={`/drivers/${row.driverId}`}>
        {row.driverFullName}
      </ColumnLink>
    ),
    minWidth: 240,
  },
  {
    headerName: 'column.car',
    field: 'carPlateNumber',
    renderCell: ({ row }) => (
      <ColumnLink to={`/cars/${row.carId}`}>{row.carPlateNumber}</ColumnLink>
    ),
    minWidth: 140,
  },
  {
    headerName: 'column.amount',
    field: 'amount',
    renderCell: ({ row }) => (
      <ColumnAmount moveFunds={row.moveFundsType} amount={row.amount} />
    ),
    minWidth: 180,
  },
  {
    headerName: 'column.balance section',
    field: 'balanceType',
    renderCell: ({ value }) => <ColumnValue>{value}</ColumnValue>,
    minWidth: 180,
  },
  {
    headerName: 'column.turnover item',
    field: 'flowStatementName',
    minWidth: 240,
  },
  {
    headerName: 'column.subdivision',
    field: 'subdivisionName',
    minWidth: 200,
  },
  {
    headerName: 'column.user or source',
    field: 'sourceType',
    minWidth: 220,
  },
]
